// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RzZr","index":"styles_index__12Sxz"};